import { Invalidation } from '~teacher/models/quizzes';

export class ValidationError extends Error {
  invalidations: Invalidation[];

  constructor(invalidations: Invalidation[]) {
    super();
    this.invalidations = invalidations;
  }
}
